import React, { FunctionComponent, useState } from 'react';
import { translate } from 'react-i18next';
import {
  ActivityIndicator,
  SafeAreaView,
  StatusBar,
  StyleSheet,
  Text,
  View,
} from 'react-native';
import { connect } from 'react-redux';
import headerImage from '../assets/images/header-images/home-bench-infront-screen-cast.jpg';
import { SelectionContainer } from '../Bookings/components/SelectionContainer';
import { TranslateProp } from '../common-types';
import { getUrls } from '../config';
import Theme from '../theme';
import { TrackingImageTile } from '../Tracking/components/TrackingImageTile';
import { toggleStrengthAssessmentModal } from '../ui';
import { defaultScale, scaleImageAspectRatio } from '../utils';
import { openLink } from '../utils/linkUtils';

interface IProps {
  t: TranslateProp;
  getNextStep(): void;
}

interface IDispatchProps {
  closeStrengthAssessmentModal(): void;
}

const SetupHomeGym: FunctionComponent<IProps & IDispatchProps> = (
  {
    t,
    getNextStep,
    closeStrengthAssessmentModal,
  },
) => {
  const [loading, setLoading] = useState(false);

  const openEquipmentSetupWebPage = async () => {
    try {
      setLoading(true);
      const urls = getUrls();
      await openLink(urls.EQUIPMENT_SETUP);
      setTimeout(() => setLoading(false), 3000);
    } catch {
      setLoading(false);
    }
  };

  return (
    <>
      <SafeAreaView style={{ flex: 0, backgroundColor: 'black' }} />
      <StatusBar barStyle='light-content' />
      <View style={{ flex: 1, backgroundColor: Theme.WHITE }}>
        <TrackingImageTile
          imageSource={headerImage}
          containerStyle={styles.headerImageContainer}
          gradientOpacity={0.6}
          gradientHeight='40%'
          useGradient
          onClosePress={closeStrengthAssessmentModal}
          contentContainerStyle={{ paddingBottom: defaultScale(5) }}
          actions={<></>}
          title={t('setupHomeGym')}
        />
        {loading && <ActivityIndicator size='small' color={Theme.PRIMARY} style={styles.loader} />}
        {!loading && (
          <>
            <Text style={styles.bodyHeading}>{t('homeGymSetupButtonsHeading')}</Text>
            <View style={styles.optionContainer}>
              <SelectionContainer
                width='100%'
                margin={10}
                height={defaultScale(110)}
                title={t('watchSetupVideosButtonTitle')}
                isSelected={false}
                subTitle={t('watchSetupVideosButtonSubTitle')}
                onPress={openEquipmentSetupWebPage}
                subTitleStyle={styles.optionSubText}
                titleStyle={styles.optionTitle}
                style={styles.optionInternalStyle}
              />
              <SelectionContainer
                width='100%'
                height={defaultScale(110)}
                title={t('startStrengthAssessment')}
                isSelected={false}
                subTitle={t('startStrengthAssessmentButtonSubtitle')}
                onPress={getNextStep}
                subTitleStyle={styles.optionSubText}
                titleStyle={styles.optionTitle}
                style={styles.optionInternalStyle}
              />
            </View>
          </>
        )}
      </View>
    </>
  );
};

const mapDispatchToProps = (dispatch): IDispatchProps => ({
  closeStrengthAssessmentModal: () => dispatch(toggleStrengthAssessmentModal(false)),
});

export default translate(['strengthAssessment'], { wait: true })(connect(null, mapDispatchToProps)(SetupHomeGym));

const styles = StyleSheet.create({
  headerImageContainer: {
    aspectRatio: scaleImageAspectRatio(1.7),
  },
  bodyHeading: {
    ...Theme.textStyle.heading,
    marginTop: defaultScale(25),
    marginBottom: defaultScale(5),
    marginLeft: defaultScale(15),
  },
  optionTitle: {
    ...Theme.textStyle.heading2,
    textAlign: 'center',
  },
  optionSubText: {
    ...Theme.textStyle.bodyCopyReg,
    textAlign: 'center',
  },
  optionContainer: {
    alignItems: 'center',
    paddingHorizontal: defaultScale(15),
  },
  optionInternalStyle: {
    paddingHorizontal: defaultScale(30),
  },
  loader: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
});
